export const logoimage = {
    img: require("../../images/png-2.png"),
};
